import React from 'react';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChangePasswordModal from './ChangePasswordModal';
import { ActionsWrapper, ChangePasswordBox } from './styles';

type EditProfileActionsProps = {
    disabled: boolean;
};

const EditProfileActions: React.FCC<EditProfileActionsProps> = ({
    disabled,
}) => {
    return (
        <ActionsWrapper>
            <ChangePasswordBox>
                <FontAwesomeIcon icon={faLock} />
                <ChangePasswordModal disabled={disabled} />
            </ChangePasswordBox>
        </ActionsWrapper>
    );
};

export default EditProfileActions;
